<div>
    <h1 mat-dialog-title class="dialog-title" [innerHTML]="data.msg"></h1>
</div>
  <div mat-dialog-actions class="dialog-action">
      <button class="btn btn-cancel" (click)="close()" class="dialog-btn">OK</button>
</div>      
